import { Store } from '../../../store/player/types';
import { goToRecordingByIndex } from './goToRecording';

/**
 * Attempt to go to next recording.
 */
export const nextRecording = (store: Store): Promise<void> => {
  const { recordingId, getRecordingIndexById } = store.getState();

  return goToRecordingByIndex(store, getRecordingIndexById(recordingId) + 1);
};
